module.exports = __webpack_public_path__ + "media/images/collage-1-90d9abc71792a76475bf78b7ae626b35.jpg";